import { render, staticRenderFns } from "./DashSettledCasesList.vue?vue&type=template&id=2f0020ee&scoped=true&"
import script from "./DashSettledCasesList.vue?vue&type=script&lang=js&"
export * from "./DashSettledCasesList.vue?vue&type=script&lang=js&"
import style0 from "./DashSettledCasesList.vue?vue&type=style&index=0&id=2f0020ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0020ee",
  null
  
)

export default component.exports